import { render, staticRenderFns } from "./DoseSelect.vue?vue&type=template&id=eec42d74"
import script from "./DoseSelect.vue?vue&type=script&lang=js"
export * from "./DoseSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports